import { ColumnNames, IBoardSection, TaskStatus } from '../../types/board';
import { ColumnIds, IMainBoard } from '../../types/mainBoard';

export function createColumnsForBoard(mainBoard: IMainBoard): IBoardSection[] {
  return [
    {
      id: ColumnIds.tomorrow,
      title: ColumnNames.tomorrow,
      tasks: mainBoard?.tomorrow,
      type: TaskStatus.backlog,
      isDropDisabled: (source: string) => false
    },
    {
      id: ColumnIds.today,
      title: ColumnNames.today,
      tasks: mainBoard?.today,
      type: TaskStatus.backlog,
      isDropDisabled: (source: string) => false
    },
    {
      id: ColumnIds.inProgress,
      title: ColumnNames.inProgress,
      tasks: mainBoard?.inProgress,
      type: TaskStatus.inProgress,
      isDropDisabled: (source: string) => false
    },
    {
      id: ColumnIds.review,
      title: ColumnNames.review,
      tasks: mainBoard?.review,
      type: TaskStatus.review,
      isDropDisabled: (source: string) => false
    },
    {
      id: ColumnIds.toBeFinished,
      title: ColumnNames.toBeFinished,
      tasks: mainBoard?.toBeFinished,
      type: TaskStatus.toBeFinished,
      isDropDisabled: (source: string) => false
    },
    {
      id: ColumnIds.done,
      title: ColumnNames.done,
      tasks: [],
      type: TaskStatus.done,
      isDropDisabled: (source: string) => false
    }
  ];
}
